/* eslint-disable react/no-array-index-key */
import { HasParentProductId, withParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getProductState,
    getVariantChildrenDataView,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button from "@insite/mobius/Button";
import LazyImage from "@insite/mobius/LazyImage";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import AuthenticatedSampleRequestForm from "@ucs/Components/AuthenticatedRequestForm/AuthenticatedSampleRequestForm";
import GuestSampleRequestForm from "@ucs/Components/GuestRequestForm/GuestSampleRequestForm";
import ProductAddToCartButton from "@ucs/Overrides/Components/ProductAddToCartButton";
import ProductAddToListLink, { ProductAddToListLinkStyles } from "@ucs/Overrides/Components/ProductAddToListLink";
import UCSColors from "@ucs/Utils/UCSColors";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const OrderSampleCompliancesWrapper = styled.div`
    background-color: ${UCSColors.gray03};
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`
                flex-direction: column;
            `,
            css`
                flex-direction: column;
            `,
        ])};
`;

const OrderSampleContainer = styled("div")<{ hasSample: boolean }>`
    background-color: ${getColor("primary")};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 50px;
    display: ${p => (p.hasSample ? "flex" : "none")};
    /* height: 100%; */
    width: 50%;
    h2 {
        color: #45ad8c;
    }
    ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`
                width: 100%;
                padding: 25px;
                button {
                    width: 100%;
                }
                h2 {
                    font-size: 32px;
                }
            `,
            css`
                width: 100%;
                padding: 25px;
                button {
                    width: 100%;
                }
                h2 {
                    font-size: 32px;
                }
            `,
            css`
                button {
                    width: 100%;
                }
                h2 {
                    font-size: 32px;
                }
            `,
        ])};
`;

const CompliancesContainer = styled.div`
    background-color: ${UCSColors.gray03};
    display: flex;
    flex-direction: row;
    align-items: center;
    /* gap: 25px; */
    justify-content: center;
    padding: 50px 10%;
    /* height: 100%; */
    width: 50%;
    h2 {
        color: #45ad8c;
    }
    button {
        border: 2px solid white;
    }
    ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`
                width: 100%;
                padding: 25px;
            `,
            css`
                width: 100%;
                padding: 25px;
            `,
        ])};
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-bottom: 0.9em;
    button {
        border: 2px solid rgba(255, 255, 255, 0.5);
    }

    ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`
                flex-direction: column;
                width: 100%;
            `,
            css`
                flex-direction: column;
                width: 100%;
            `,
            css`
                flex-direction: column;
                width: 100%;
            `,
        ])};
`;

const ComplianceItem = styled.div`
    height: 60px;
    width: 90px;
    padding-right: 12px;
    padding-left: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid ${UCSColors.gray04};
    &:last-child {
        border-right: none;
    }
    img {
        height: 60px;
    }
`;

type Props = ReturnType<typeof mapStateToProps> & HasProductContext & HasParentProductId;

const mapStateToProps = (state: ApplicationState, ownProps: HasParentProductId) => ({
    isAuthenticated: state.context.session!.isAuthenticated,
    pVariantChildren: getVariantChildrenDataView(state, ownProps.parentProductId).value,
    parentProduct: getProductState(state, ownProps.parentProductId).value,
    saveSampletoList: state.context.settings.properties?.saveSampletoList,
});

const OrderSampleCompliances: React.FC<Props> = ({
    productContext: { product },
    isAuthenticated,
    pVariantChildren,
    parentProduct,
    saveSampletoList,
}: Props) => {
    let hasSample = false;
    const compliances: string[] = [];
    let sampleProduct;
    const [showModal, setShowModal] = React.useState(false);

    if (parentProduct && pVariantChildren && pVariantChildren.length > 0) {
        if (parentProduct.attributeTypes) {
            parentProduct.attributeTypes.forEach(attribute => {
                if (attribute.name.toLowerCase().includes("hassample")) {
                    attribute.attributeValues?.forEach(attributeValue => {
                        if (attributeValue.value.toLowerCase() === "yes") {
                            pVariantChildren.forEach(variantChild => {
                                if (
                                    variantChild.productNumber.toLowerCase() ===
                                    `${parentProduct.productNumber.toLowerCase()}s`
                                ) {
                                    hasSample = true;
                                    sampleProduct = variantChild;
                                }
                            });
                        }
                    });
                }
            });
        }
    }

    if (product.attributeTypes) {
        product.attributeTypes.forEach(attribute => {
            if (attribute.name.toLowerCase().includes("complianceandcertification")) {
                attribute.attributeValues?.forEach(attributeValue => {
                    compliances.push(attributeValue.value);
                });
            }
        });
    }

    compliances.sort();

    return (
        <OrderSampleCompliancesWrapper>
            <CompliancesContainer>
                {compliances.map((compliance, i) => (
                    <ComplianceItem key={i}>
                        <LazyImage src={`/UserFiles/compliance/${compliance}_pdp.svg`}></LazyImage>
                    </ComplianceItem>
                ))}
            </CompliancesContainer>
            {sampleProduct && (
                <>
                    <OrderSampleContainer hasSample={hasSample}>
                        <Typography as="h2" variant="h2">
                            Experience this product
                        </Typography>
                        <ButtonWrapper>
                            {isAuthenticated ? (
                                <>
                                    {/* <ProductAddToCartButton
                                        labelOverride="ORDER SAMPLE"
                                        data-test-selector="addToCartBtn"
                                        overrideProduct={sampleProduct}
                                    /> */}
                                    <>
                                        <Button onClick={() => setShowModal(true)}>
                                            {siteMessage("Order_Sample")}
                                        </Button>
                                        <AuthenticatedSampleRequestForm
                                            sampleProduct={sampleProduct}
                                            isModalOpen={showModal}
                                            toggleModal={() => setShowModal(!showModal)}
                                        />
                                    </>     
                                    {   saveSampletoList?.toLocaleLowerCase() === "true" &&
                                        <ProductAddToListLink
                                        data-test-selector="productDetails_addToList"
                                        labelOverride="SAVE SAMPLE TO LIST"
                                        overrideProduct={sampleProduct}
                                        />
                                    }
                                </>
                            ) : (
                                <>
                                    <Button onClick={() => setShowModal(true)}>
                                    { isAuthenticated ? 
                                        siteMessage("Order_Sample") :
                                        siteMessage("Request_A_Sample")
                                    }
                                    </Button>
                                    <GuestSampleRequestForm
                                        sampleProduct={sampleProduct}
                                        isModalOpen={showModal}
                                        toggleModal={() => setShowModal(!showModal)}
                                    />
                                </>
                            )}
                        </ButtonWrapper>
                        <Typography color="white">{siteMessage("Sample_Compliances_Message")}</Typography>
                    </OrderSampleContainer>
                </>
            )}
        </OrderSampleCompliancesWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withParentProductId(withProductContext(connect(mapStateToProps)(OrderSampleCompliances))),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
